import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function ReasonModal({
  applicationId,
  id,
  updateList,
  formData,
  setFormData,
  createTextArea,
  updateMachineryPropertyAssessmentTaxability,
  isLoading,
  getList,
  getCodedValueList,
  codedValueList,
}) {
  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      taxability: 0,
    };
    updateMachineryPropertyAssessmentTaxability(applicationId, id, args, () => {
      setModal({ isOpen: false });
      getList(applicationId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.TAXABILITY_FORM_DATA)));
    }
  };

  useEffect(() => {
    getCodedValueList();
  }, []);

  useEffect(() => {
    onSetFormData();
  }, []);

  const listOption =
    codedValueList.map((item) => ({
      label: _.get(item, 'attributes.name'),
      value: _.get(item, 'id'),
    })) || '';

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <Select
              name="tax_exempt_code_id"
              placeholder="Select"
              onChange={handleOnChangeSelect('tax_exempt_code_id')}
              options={listOption}
              value={
                listOption.find((item) => {
                  return (
                    `${_.get(formData, 'tax_exempt_code_id')}` ===
                    _.get(item, 'value')
                  );
                }) || ''
              }
            />
          </div>
          <div className="col-12 form-group">
            {createTextArea(
              { key: 'tax_exempt_reason', label: 'Exemption Reason:' },
              { required: true }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
            disabled={isLoading}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark"
            disabled={isLoading}
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ReasonModal.defaultProps = {
  applicationId: '',
};

ReasonModal.propTypes = {
  applicationId: PropTypes.string,
  id: PropTypes.string.isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  updateMachineryPropertyAssessmentTaxability:
    PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  codedValueList: PropTypes.instanceOf(Array).isRequired,
  getCodedValueList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  codedValueList: _.get(api, `${c.GET_CODED_VALUE_LIST}.list`) || [],
  isLoading:
    _.get(api, 'loading', []).indexOf(
      c.UPDATE_MACHINERY_PROPERTY_ASSESSMENT_TAXABILITY
    ) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ReasonModal);
